import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { Faq } from '../components/Faq';
import { TryIt } from '../components/how/TryIt';
import { LibraryShelves } from '../components/how/LibraryShelves';
import { asset } from '../data/redesignAssets';
import { USE_STEPS } from '../data/howShelves';
import { AGENT_STEPS, RECEIPT_HEAD, RECEIPT_RULES } from '../data/howReceipt';
import { faqsHow } from '../data/faqsHow';
export function How() {
  return <>
      <Section n="01" label="How it works" noTop contentClassName="hero-c how-hero" data-id="element-527" data-mp="2v9nm56b8uqkv">
        <img className="swirl" src={asset('hero-swirl-how.svg')} alt="" width={269} height={446} style={{
        right: 43,
        top: 13
      }} data-id="element-528" data-mp="2qastlcnh5nnk" />
        <h1 className="h1" style={{
        maxWidth: 700
      }} data-id="element-529" data-mp="2le2f2trbj049">
          Your rules and your judgment
          <br className="d" data-id="element-530" data-mp="oixzuc16c3tm" /> in one library, governing
          <br className="d" data-id="element-531" data-mp="jle8cafgtujq" /> the answers that matter.
        </h1>
        <p className="lede" data-id="element-532" data-mp="jj1t4513dyad">
          Everything your company already knows, turned into instruction data and put in front of every model and every agent before it
          acts. Here’s how the library gets built, how it gets used, and what it means for the people and agents who work with it.
        </p>
      </Section>

      <TryIt data-id="element-533" data-mp="21h6a0yhf2xhp" />

      <Section n="03" label="Build it" data-id="element-534" data-mp="21gmnf4gtnkxc">
        <div className="hgroup" data-id="element-535" data-mp="21hoay8f0xzvy">
          <h2 className="h2" style={{
          maxWidth: 980
        }} data-id="element-536" data-mp="2p6qrte1u3ope">
            Everything that carries judgment goes in.
            <br className="d" data-id="element-537" data-mp="2u5k7nd4lfrsq" /> Instruction data comes out.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-538" data-mp="2u7wjd8jrd5xc">
            What goes in: your industry’s regulations, your policies, your best reviewer’s corrections, your agent runbooks, and the
            institutional knowledge nobody wrote down. What comes out: one rule at a time, plain English on top, hashed and versioned
            underneath, each with an owner and a trigger.
          </p>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-539" data-mp="3cyednhk8o9kt">
            The library doesn’t start empty. It starts from a governed baseline, 100,000 rules covering the Fortune 1000 and their
            subsidiaries, regulatory, brand, and role, and becomes yours the first time your best reviewer’s correction goes in. Generic
            goes in once. What comes back is yours and never returns to the marketplace.
          </p>
        </div>
        <LibraryShelves data-id="element-540" data-mp="33tzat11dwybx" />
      </Section>

      <Section n="04" label="Use it" data-id="element-541" data-mp="33v0n18u4zqv8">
        <div className="hgroup" data-id="element-542" data-mp="2z2pi1rkjhevt">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-543" data-mp="2z1o7do7fquem">
            Before the AI answers,
            <br className="d" data-id="element-544" data-mp="2u2uwm3jj9hi5" /> it checks your library.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-545" data-mp="2q212utjet8hc">
            Someone asks the AI for something. Before the AI answers, Synthia goes to the library, picks out the rules that apply to that
            request, puts the ones that can’t be skipped at the front, and hands the whole thing to the model as one request. Then it
            writes down what it sent and signs it. That’s the receipt.
          </p>
        </div>
        <div className="use-g" data-id="element-546" data-mp="10k49l0dduib2">
          <img src={asset('flow-chart.svg')} alt="Flow: your prompt, situational rules, and always-on rules assemble into one request; if the required rules are in, it goes to the model with a signed receipt, otherwise it is blocked and logged." data-id="element-547" data-mp="10j2m1wf6k3cg" />
          <div className="steps" data-id="element-548" data-mp="cvkykd2y7rfa">
            {USE_STEPS.map(s => <div className="step" key={s.t} data-id="element-549" data-mp="cti0r6vk0u00">
                <div className="t" data-id="element-550" data-mp="hvh7mqqi691p">{s.t}</div>
                <div className="b" data-id="element-551" data-mp="hsbdgx30ogz4">{s.b}</div>
              </div>)}
          </div>
        </div>
        <p className="say" data-id="element-552" data-mp="lu6fk3sruydy">If the always-on rules can’t go in, the request doesn’t run.</p>
      </Section>

      <Section n="05" label="For people" data-id="element-553" data-mp="3qa7kdx2exnlf">
        <div className="hgroup" data-id="element-554" data-mp="3q966zlxxcp0j">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-555" data-mp="3q84wbiktm4jc">
            The first pass is the last pass.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-556" data-mp="3b77iz4e94wps">
            The reviewer stops correcting the same thing for the fifth time, because the correction became a rule the AI has to follow.
            Fewer revisions, less rework, and less risk: the disclosure that used to depend on someone noticing is now in the request
            before the model writes a word.
          </p>
        </div>
        <img src={asset('revision-chart.svg')} alt="Without Synthia: five revisions before approval. With the must-haves in first: one revision before approval." style={{
        display: 'block',
        width: '100%',
        maxWidth: 900,
        padding: '8px 0'
      }} data-id="element-557" data-mp="3txp9d2bm3g7z" />
      </Section>

      <Section n="06" label="The receipt" data-id="element-558" data-mp="7o4t26tcpz8e">
        <div className="hgroup" data-id="element-559" data-mp="2sfr5wtv068x">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-560" data-mp="2s5wvx1s7cxf">
            You can’t reconstruct a decision
            <br className="d" data-id="element-561" data-mp="29i418jb6g0gv" /> you never governed.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-562" data-mp="24jstce4g001a">
            When the auditor asks why the model said what it said, “we retrieved some relevant passages” is not an answer. It isn’t even a
            defense.
          </p>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-563" data-mp="oz0e1xi3xz0q">
            A receipt is an answer: which rules went in, which versions, what triggered them, when, and a signature. Every request ships
            with its proof, before anyone asks for it. You don’t reconstruct the decision. You hand over the record.
          </p>
        </div>
        <div className="rcpt" data-id="element-564" data-mp="5bkku29a7e8t">
          <div className="rh" data-id="element-565" data-mp="5clty16qlqnw">
            <span data-id="element-566" data-mp="59pug8f8qtxc">/ INSTRUCTION RECEIPT</span>
            <span data-id="element-567" data-mp="3ni8m1h17nh97">#cr-7842</span>
          </div>
          <div className="kv bb" data-id="element-568" data-mp="3nja0lvhfqlvo">
            {RECEIPT_HEAD.map(r => <React.Fragment key={r.k} data-id="element-569" data-mp="3shbgy8nh873g">
                <span className="k" data-id="element-570" data-mp="3sid1r4uao7yd">{r.k}</span>
                <span data-id="element-571" data-mp="1lr3t8hnjkana">{r.v}</span>
              </React.Fragment>)}
          </div>
          <div className="rh" data-id="element-572" data-mp="1qo4210brzri3">RULES · {RECEIPT_RULES.length}/{RECEIPT_RULES.length} INCLUDED</div>
          <div data-id="element-573" data-mp="1p91cm499hm3m">
            {RECEIPT_RULES.map((r, i) => <div className="rr" key={r.id} data-id="element-574" data-mp="1k8ww4e8csrde" data-mpi={i}>
                <span className="k" data-id="element-575" data-mp="1k83x5zfmz65t">{String(i + 1).padStart(2, '0')}</span>
                <span data-id="element-576" data-mp="1f9akg986bj6p">{r.id}</span>
                <span style={{
              color: 'var(--mut)'
            }} data-id="element-577" data-mp="1fac432399e01">{r.v}</span>
                <span style={{
              color: 'var(--green)'
            }} data-id="element-578" data-mp="1abiq78k23kzc">fired</span>
              </div>)}
          </div>
          <div className="kv" data-id="element-579" data-mp="27xg5yy71xc7l">
            <span className="k" data-id="element-580" data-mp="280keg7rjuu42">algorithm</span>
            <span data-id="element-581" data-mp="22z4t0elgmll5">ed25519</span>
            <span className="k" data-id="element-582" data-mp="22zwqxw2j4vel">digest</span>
            <span data-id="element-583" data-mp="1y8ocglmcejuk">9f3a71…d41c</span>
            <span className="k" data-id="element-584" data-mp="1y7mtzw2zyv2t">2026-09-05</span>
            <span className="sig" data-id="element-585" data-mp="1y6bp1sxtfha4">
              <span data-id="element-586" data-mp="1tad6ilz64thm">14:02:11 UTC</span>
              <span className="signed" data-id="element-587" data-mp="1t9bi7ft56ahy">SIGNED</span>
            </span>
          </div>
        </div>
      </Section>

      <Section n="07" label="For agents" data-id="element-588" data-mp="2qr21pwtm4xi1">
        <div className="hgroup" data-id="element-589" data-mp="2ly0lnlho6rwv">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-590" data-mp="2lwplrwrci4b1">
            Chat forgives. Agents commit.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-591" data-mp="2u8zlvln5qczf">
            In chat, the safety net is a person skimming on a deadline. An agent chain has no one skimming. A rule missed at step three is a
            transaction committed at step seven, and nobody was in between.
          </p>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-592" data-mp="387za4s6rcpv2">
            So the library rides inside the chain, every step, with a receipt at every hop. An agent that satisfies the rules runs. One that
            doesn’t gets held, and the receipt says why and who it’s waiting on.
          </p>
        </div>
        <div className="chain" data-id="element-593" data-mp="3lyuk67sztd08">
          <div className="eyebrow" data-id="element-594" data-mp="3qww5kzdw5oev">AGENT · NO ONE BETWEEN THE STEPS</div>
          <div className="chain-g" data-id="element-595" data-mp="3qz9wcw1jgegm">
            {AGENT_STEPS.map(s => <div className={`cs${s.kind ? ` ${s.kind}` : ''}`} key={s.n} data-id="element-596" data-mp="3vxtlf5bfi6d7">
                {s.n}
                {s.kind === 'omit' && <span data-id="element-597" data-mp="4nuxgsvhbhg4">OMISSION</span>}
                {s.kind === 'commit' && <span data-id="element-598" data-mp="pzuomlroug9v">COMMIT</span>}
              </div>)}
          </div>
          <div className="mono" style={{
          fontSize: 12,
          color: 'var(--mut)'
        }} data-id="element-599" data-mp="l2m80pm6ukaq">
            the omission clears at step 7 · no reviewer was there
          </div>
        </div>
      </Section>

      <Section n="08" label="What you keep" className="gridpaper bleed" data-id="element-600" data-mp="u1zklr5lzozo">
        <div className="hgroup" data-id="element-601" data-mp="u0oc5e17xt28">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-602" data-mp="6c58xcx106h0">
            The model, you rent.
            <br data-id="element-603" data-mp="2bv1dvtl5801" />
            The engine, you subscribe to.
            <br data-id="element-604" data-mp="298ln8wjjm6q" />
            The instructions, you own.
          </h2>
          <p className="lede" style={{
          maxWidth: 820
        }} data-id="element-605" data-mp="g3hwhsbskah8">
            The library lives inside your walls. It trains nothing but yours. It compiles for whatever model you rent next, and it
            appreciates with every correction your people make. It’s the only part of your AI stack that gets more valuable the longer you
            run it.
          </p>
        </div>
      </Section>

      <Section n="09" label="FAQ" data-id="element-606" data-mp="1u9mp9sdtk5wl">
        <h2 className="h2" data-id="element-607" data-mp="1u8l4gw70451o">Asked and answered.</h2>
        <div style={{
        maxWidth: 820
      }} data-id="element-608" data-mp="1z1o33iqmy4oq">
          <Faq items={faqsHow} data-id="element-609" data-mp="1z3imgsm9doqp" />
        </div>
      </Section>

      <StartHere n="10" data-id="element-610" data-mp="1lb2fxhu5f8l1" />
    </>;
}